import { Pipe, PipeTransform } from '@angular/core';

import pluralize from 'pluralize';

@Pipe({
  name: 'pluralize'
})
export class PluralizePipe implements PipeTransform {
  constructor () {
    pluralize.addPluralRule('Tech', 'Techs');
    pluralize.addPluralRule('Mech', 'Mechs');
  }

  transform( value : string ) : string {
    if (!value) return '';

    return pluralize.plural(value);
  }
}